import { render, staticRenderFns } from "./DocumentContentGridCard.vue?vue&type=template&id=d68a4cca"
import script from "./DocumentContentGridCard.vue?vue&type=script&lang=js"
export * from "./DocumentContentGridCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentGridCard.vue?vue&type=style&index=0&id=d68a4cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports